<template>
  <v-dialog v-model="dialog" persistent width="800">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Ubah Surel</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
      <v-container>
        <v-row row wrap justify="center" align="center">
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-card flat>
              <v-card-text>
                <v-form @submit.prevent data-vv-scope="form" lazy-validation class="pt-5">
                  <v-text-field
                    outlined dense
                    autofocus
                    label="Masukkan Surel"
                    v-model="form.email"
                    hint="Masukkan surel baru yang akan digunakan"
                    data-vv-name="email"
                    data-vv-as="Surel"
                    v-validate="'required|email'"
                    type="text"
                    :error-messages="errors.collect('form.email')"
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-card>
            <v-col cols="12" md="12">
              <div class="text-right">
                <v-btn color="primary" depressed @click="setEmail">Simpan</v-btn>
              </div>
            </v-col>
          </v-col>
        </v-row>
      </v-container>
     </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      uid: null,
      form: {},
      dialog: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    // eslint-disable-next-line
    open({ id }) {
      this.uid = id
      this.form = {}
      this.$validator.reset();
      this.dialog = true
    },
    setEmail() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("user/updateEmail", {
            user_id: this.uid,
            params: this.form
          });
        })
        .then(() => {
          this.$success('Aksi berhasil dilakukan')
          this.$emit('reload')
          this.dialog = false
        })
        .catch(e => e);
    }
  }
};
</script>
